export const RENEWAL_NOTICE_MONTHS = 1;

export const RENEWAL_NOTICE_MESSAGE = `Approved entries will be flagged for renewal ${RENEWAL_NOTICE_MONTHS === 1 ? "one month" : `${RENEWAL_NOTICE_MONTHS} months`} before their expiry date.`;
